module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mode === 'SELF_REPORTED') ? _c('div', {
    staticClass: "insetGraph"
  }, [(_vm.$store.state.user.scope) ? _c('activity-line-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    },
    on: {
      "onTrackingType_activity": _vm.onTrackingTypeActivity
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'STEPS') ? _c('div', {
    staticClass: "insetGraph"
  }, [(_vm.$store.state.user.scope) ? _c('activity-steps-line-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    },
    on: {
      "onTrackingType_activity": _vm.onTrackingTypeActivity
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 auto",
      "text-align": "center"
    }
  }), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [_c('activity-input', {
    staticClass: "card-spacing",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "bmr": _vm.$store.state.user.stats.bmr
    }
  }), _vm._v(" "), (_vm.mode === 'STEPS') ? _c('activity-wearable-visualisation') : _vm._e(), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-tabs', {
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "STEPS"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'STEPS'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelSteps').charAt(0).toUpperCase() + _vm.$t('message.labelSteps').substr(1)))]), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "SELF_REPORTED"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'SELF_REPORTED'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelManualEntry')))])], 1), _vm._v(" "), (_vm.mode === 'SELF_REPORTED') ? _c('div', [_c('mu-timeline', [_vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelActivityType')) + ": " + _vm._s(_vm.getLocaleLabel(item.type)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelCaloriesBurnt')) + ": " + _vm._s(item.calories_burnt) + " kcal")])]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [_vm._v("\n                          " + _vm._s(item.minutes) + " " + _vm._s(_vm.$t('message.labelMinute')) + "\n                        ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e()])], 1)
    })], 2)
  }), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.loadingText')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'STEPS') ? _c('div', [_c('mu-timeline', [(_vm.data.data.length === 0 && !_vm.isReadingsLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "24px"
    }
  }, [_c('h3', [_vm._v("You don't have any steps data yet")]), _vm._v(" "), _c('p', [_vm._v("To get started connect your favorite health app below")]), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "Add an activity integration"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getStartedIntegrations.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedStepDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [_c('img', {
        staticStyle: {
          "position": "relative",
          "top": "8px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "24",
          "src": "static/ic_watch_activity.svg"
        }
      }), _vm._v(_vm._s(item.device))]), _vm._v(" "), _c('span', [_c('img', {
        staticStyle: {
          "position": "relative",
          "top": "8px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "24",
          "src": "static/ic_hk_activity.svg"
        }
      }), _vm._v(_vm._s(_vm.$t('message.labelCaloriesBurnt')) + ": " + _vm._s(_vm.numberFormat(item.calories)) + " kcal")]), _vm._v(" "), _c('div', [_c('img', {
        staticStyle: {
          "position": "relative",
          "top": "8px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "24",
          "src": "static/ic_floors_climbed.svg"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('message.labelFloorsClimbed')) + ":\n                          " + _vm._s(item.floors) + "\n                        ")])]), _vm._v(" "), _c('mu-col', [_c('div', {
        staticClass: "reading"
      }, [_vm._v(_vm._s(_vm.numberFormat(item.steps)) + " " + _vm._s(_vm.$t('message.labelSteps')))])])], 1)], 1) : _vm._e()])], 1)
    })], 2)
  }), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.loadingText')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 2)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4985204f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tracking/Activity.vue
// module id = 3711
// module chunks = 1